import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from "react";
import classnames from "classnames";
import { useEffect, useState } from "react";
import styles from "../styles/Loading.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var IconSpiner = function IconSpiner(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fill: "#09F",
      d: "M24 44c2 0 3.9-.2 5.8-.7 1.9-.6 3.7-1.4 5.4-2.4 1.7-1.1 3.2-2.4 4.5-3.9 1.3-1.5 2.4-3.2 3.2-5.1.8-1.8 1.3-3.8 1.6-5.8.2-2 .2-4.1-.2-6.1s-1-4-1.9-5.8c-1-1.8-2.2-3.5-3.6-5-1.5-1.5-3.1-2.7-4.9-3.8-1.8-1-3.8-1.7-5.8-2.2-2-.4-4.1-.6-6.2-.4-2.1.2-4.2.6-6.1 1.4-2 .8-3.8 1.8-5.5 3.1-1.6 1.3-3.1 2.9-4.4 4.6-1.2 1.8-2.2 3.7-2.8 5.7-.7 2-1 4.2-1.1 6.3 0-2.2.2-4.3.8-6.4.6-2.1 1.5-4.1 2.7-5.9 1.2-1.8 2.7-3.5 4.3-4.9 1.7-1.4 3.6-2.6 5.6-3.5 2-.9 4.2-1.4 6.4-1.7 2.2-.2 4.4-.2 6.7.2 2.2.4 4.3 1.1 6.3 2.1s3.8 2.4 5.5 3.9c1.6 1.6 3 3.4 4.1 5.4 1.1 2 1.9 4.1 2.4 6.4.5 2.2.6 4.5.5 6.8-.2 2.3-.7 4.5-1.5 6.7-.9 2.1-2 4.2-3.4 6-1.5 1.8-3.2 3.4-5.1 4.8-1.9 1.3-4 2.3-6.3 3.1-2.2.7-4.6 1.1-6.9 1.2-1.1 0-2-.8-2.1-1.9s.8-2 1.9-2.1c0-.1 0-.1.1-.1z"
    })
  }));
};
IconSpiner.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48",
  xmlSpace: "preserve"
}; // showStartにミリ秒を指定すると表示開始を遅らせることができる。
// 一瞬だけローディングがでて微妙という場合に使う想定
export default function Loadingprogressbar(_ref) {
  let {
    fixed,
    showStart
  } = _ref;
  const {
    0: show,
    1: setShow
  } = useState(showStart ? false : true);
  useEffect(() => {
    let timeoutId;
    if (showStart) {
      timeoutId = setTimeout(() => setShow(true), showStart);
    }
    return () => {
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, []);
  if (!show) return null;
  return /*#__PURE__*/_jsxs("div", {
    className: classnames(styles.wrapper, {
      [styles.fixed]: fixed
    }),
    children: [/*#__PURE__*/_jsx("div", {
      className: styles.loaderCont,
      children: /*#__PURE__*/_jsx(IconSpiner, {
        className: styles.fillMainColor
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.progressbarContainer,
      children: [/*#__PURE__*/_jsx("div", {
        className: styles.progressbar,
        children: " "
      }), /*#__PURE__*/_jsx("div", {
        className: styles.progressbarIcon,
        children: " "
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.text,
      children: [/*#__PURE__*/_jsx("p", {
        children: "\u3053\u3053\u304B\u3089\u306F\u30E1\u30F3\u30D0\u30FC\u30BAID\u306E\u624B\u7D9A\u304D\u306B\u306A\u308A\u307E\u3059"
      }), /*#__PURE__*/_jsx("p", {
        children: "(\u30B9\u30AB\u30D1\u30FC\uFF01\u30E1\u30F3\u30D0\u30FC\u30BA\u306E\u30B5\u30A4\u30C8\u306B\u9077\u79FB\u3057\u307E\u3059)"
      })]
    })]
  });
}